import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {STEP_REG, unixNow, c2js} from './Util.js';
import TripDialog from './TripDialog.js';
import {COMM_OK} from './WsR2.js';
import Trip from './Trip.js';

function getStyles(id, array) {
  	return {
    		fontWeight:
      			array.indexOf(id) === -1
        			? 'normal'
        			: 'bold'
  		};
}

const AddReg = observer(() => {
	const [actTripIsOpen, setActTripOpen] = useState(false);
	const [tripIsOpen, setTripOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function addRegRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('addRegRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'trip') {
			if (msg.op === 'list') {
				if (msg.result === 'OK') {
					let _triplist = {
						last_upd: unixNow(),
						list: msg.data.triplist ? msg.data.triplist : [],
					}

					console.log('addRegRxWs: trip list loading OK!');

					gStorage.lists.setTripList(_triplist);
				} else {
					console.error('addRegRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('addRegRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('addRegRxWs: invalid command', msg.cmd);
			return -1;
		}
	}

	function hiddenChange(event, value) {
		gStorage.add.setHidden(value ? 1 : 0);
	}

	function userChange(event) {
		if (gStorage.add.personID.includes(gStorage.conn.user.id) && !event.target.value.includes(gStorage.conn.user.id))
			return;

		gStorage.add.setPersonID(event.target.value);
	}

	const userList = gStorage.lists.userlist.list.map((dt, i) => {
		if (dt.id === gStorage.conn.user.id || dt.allow_friend === 1)
			return (<MenuItem key={dt.id} value={dt.id} style={getStyles(dt.id, gStorage.add.personID)}>{dt.first_name + ' ' + dt.last_name}</MenuItem>);

		return null;
	});

	function tripChange(event, value) {
		gStorage.add.setTripID(event.target.value);
	}

	const tripList = gStorage.lists.triplist.list.map((dt, i) => {
		if (dt.id !== 0 && dt.active && dt.public_trip)
			return (<MenuItem key={dt.id} value={dt.id} style={getStyles(dt.id, gStorage.add.tripID)}>{dt.name}</MenuItem>);

		return null;
	});

	function openActTripDialog() {
		const trip1 = gStorage.lists.triplist.list.find((trip) => trip.id === gStorage.conn.user.trip1);
		if (!trip1) {
			/* Remove invalid value from obs trips */
			gStorage.add.setTripID(gStorage.add.tripID.slice().filter(item => item !== gStorage.conn.user.trip1));
			gStorage.conn.setUser({...gStorage.conn.user, trip1: 0});
		}

		const trip2 = gStorage.lists.triplist.list.find((trip) => trip.id === gStorage.conn.user.trip2);
		if (!trip2) {
			/* Remove invalid values from obs trips */
			gStorage.add.setTripID(gStorage.add.tripID.slice().filter(item => item !== gStorage.conn.user.trip2));
			gStorage.conn.setUser({...gStorage.conn.user, trip2: 0});
		}

		const trip3 = gStorage.lists.triplist.list.find((trip) => trip.id === gStorage.conn.user.trip3);
		if (!trip3) {
			/* Remove invalid values from obs trips */
			gStorage.add.setTripID(gStorage.add.tripID.slice().filter(item => item !== gStorage.conn.user.trip3));
			gStorage.conn.setUser({...gStorage.conn.user, trip3: 0});
		}

		setActTripOpen(true);
	}

	function actTripClose() {
		let tripID = [];

		setActTripOpen(false);

		if (gStorage.conn.user.trip1 > 0)
			tripID.push(gStorage.conn.user.trip1);
		if (gStorage.conn.user.trip2 > 0)
			tripID.push(gStorage.conn.user.trip2);
		if (gStorage.conn.user.trip3 > 0)
			tripID.push(gStorage.conn.user.trip3);

		gStorage.add.setTripID(tripID);
	}

	function openTripDialog() {
// 		gStorage.trips.setTrip({id:0, user_id:gStorage.conn.user.id,name:t('trips.trip') + ' '  + dStr(unixNow()), desc:'', public_trip:1, active:1});
		gStorage.trips.newTrip(true);
		gStorage.trips.setChanged(true);
		setTripOpen(true);
	}

	function tripClose(changed) {
		setTripOpen(false);

		if (!changed)
			return;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'list'
		};

		console.log('newTripClose: loading list!');

		gStorage.conn.ws.send(msg, addRegRxWs);
	}

	/* Optional user settings ------------------------------------------- */

	function chk1Change(event, value) {
		gStorage.add.setChk1(value ? 1 : 0);
	}

	function addRegChk1() {
		if (gStorage.conn.user.chk1_desc <= 0)
			return null;
		
		return (<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={gStorage.conn.user.chk1_desc}
					labelPlacement="start"
					checked={!!gStorage.add.obs.chk1}
					onChange={chk1Change}
					control={<Checkbox color="primary" />}
					style={{margin: 4}}
				/>
			</Grid>);
	}

	function chk2Change(event, value) {
		gStorage.add.setChk2(value ? 1 : 0);
	}

	function addRegChk2() {
		if (gStorage.conn.user.chk2_desc <= 0)
			return null;

		return (<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={gStorage.conn.user.chk2_desc}
					labelPlacement="start"
					checked={!!gStorage.add.obs.chk2}
					onChange={chk2Change}
					control={<Checkbox color="primary" />}
					style={{margin: 4}}
				/>
			</Grid>);
	}

	function color1Change(event, value) {
		gStorage.add.setColor1(value ? 1 : 0);
	}

	function c1bgColor() {
		if (!gStorage.conn.user.color1 || !gStorage.conn.user.color1_desc || gStorage.conn.user.color1_desc.length <= 0)
			return 'primary';

		return c2js(gStorage.conn.user.color1);
	}

	function addRegColor1() {
		if (gStorage.conn.user.color1_desc <= 0 || !gStorage.conn.user.color1)
			return null;
		
		return (<Grid size={{xs: 12}} align={'center'}>
			<FormControl variant="outlined" size="small" align='center'>
				<FormControlLabel
					label={gStorage.conn.user.color1_desc}
					labelPlacement="start"
					checked={!!gStorage.add.obs.color1}
					onChange={color1Change}
					control={<Checkbox color="primary" />}
					style={{margin: 4, width: 300, justifyContent: "center", borderStyle: "dotted", borderWidth: 1, backgroundColor:c1bgColor()}}
				/>
			</FormControl>
			</Grid>);
	}

	function color2Change(event, value) {
		gStorage.add.setColor2(value ? 1 : 0);
	}

	function c2bgColor() {
		if (!gStorage.conn.user.color2 || !gStorage.conn.user.color2_desc || gStorage.conn.user.color2_desc.length <= 0)
			return 'primary';

		return c2js(gStorage.conn.user.color2);
	}

	function addRegColor2() {
		if (gStorage.conn.user.color2_desc <= 0)
			return null;

		return (<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={gStorage.conn.user.color2_desc}
					labelPlacement="start"
					checked={!!gStorage.add.obs.color2}
					onChange={color2Change}
					control={<Checkbox color="primary" />}
					style={{margin: 4, width: 300, justifyContent: "center", borderStyle: "dotted", borderWidth: 1, backgroundColor:c2bgColor()}}
				/>
			</Grid>);
	}

	/* ------------------------------------------------------------------ */

	if (gStorage.add.currentStep !== STEP_REG)
		return null;

	return (
		<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('add.hidden')}
						labelPlacement="start"
						checked={!!gStorage.add.obs.hidden}
						onChange={hiddenChange}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small">
						<InputLabel>{t('add.observers')}</InputLabel>
						<Select
							multiple
							value={gStorage.add.personID}
							onChange={userChange}
							style={{width: 300, margin: 8}}>
								{userList}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small">
						<InputLabel>{t('add.obs_trips')}</InputLabel>
						<Select
							multiple
							value={gStorage.add.tripID}
							onChange={tripChange}
							style={{width: 300, margin: 8}}>
								{tripList}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Button 
					    variant="contained" 
					    color="primary" 
					    style={{width:300, margin:8, align: 'center'}} 
					    onClick={openActTripDialog}
					    disabled={!gStorage.conn.online}>
						{t('add.active_trips')}
					</Button>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Button 
					    variant="contained" 
					    color="primary" 
					    style={{width:300, margin:8, align: 'center'}} 
					    onClick={openTripDialog}
					    disabled={!gStorage.conn.online}>
						{t('add.add_trip')}
					</Button>
				</Grid>
				{addRegChk1()}
				{addRegChk2()}
				{addRegColor1()}
				{addRegColor2()}
			</Grid>

			<TripDialog isOpen={actTripIsOpen} handleClose={actTripClose} />
			<Trip isOpen={tripIsOpen} handleClose={tripClose} />
		</div>
	);
});

export default AddReg;
